'use client'

import dynamic from 'next/dynamic'
import { FC } from 'react'

const MarkdownView = dynamic(() => import('@/components/ui/markdown-view/markdown-view').then((mod) => mod.MarkdownView), { ssr: false })

export interface PerformerCardProps {
  name: string
  profile?: string | null
  department?: string | null
}

const PerformerCard: FC<PerformerCardProps> = ({ name, profile, department }) => {
  return (
    <div className="performer-members">
      <div className="performer-header">
        <div className="performer-avatar">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <circle cx="12" cy="8" r="4" />
            <path d="M20 21a8 8 0 1 0-16 0" />
          </svg>
        </div>
        <div className="performer-info">
          <div className="info-section-value">{name}</div>
          {department && <div className="performer-department">{department}</div>}
        </div>
      </div>
      {profile && (
        <div className="performer-profile">
          <MarkdownView content={profile} />
        </div>
      )}
    </div>
  )
}

export default PerformerCard
